<script>;
import Navbar from "@/components/navbar";
import FooterBG from "@/components/footer-bg";
export default {
  components: {
    Navbar,
    // Partners,
    // BlogMarketing,
    // Contact,
    FooterBG,
  }
};
</script>
<style scoped>
.black-text
{
  color: black !important;
}
</style>
<template>
  <div>
    <Navbar />

    <div v-scroll-spy>
      <!--START HOME-->
      <section
        class="section bg-home height-100vh"
        id="home"
        :style="{'background-image': 'url(' + require('@/assets/images/fanmath-images/teacher1.jpg') + ')', 'background-size': 'cover','background-position': 'center' }"
      >
      <div class="bg-overlay"></div>
        <div class>
          <div class>
            <div class="container slidero">
              <div class="row">
                <div class="col-lg-8 offset-lg-2 text-white text-center">
                  <h1 style="color: orange" class="home-title">Преподавател</h1>
                  <h4 style="text-decoration: underline; text-decoration-color: orange;text-underline-offset: 10px" class="home-small-title">Запознайте се с преподавателя на школата</h4>
                  <p
                    class="padding-t-15 home-desc mx-auto"
                  ></p>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- Particles -->
        <!-- <vue-particles class="position-relative" color="#FFF"></vue-particles> -->
        
      </section>

      <!--END HOME-->

 <section class="section" id="features">
    <div class="container">
      <div class="row">
        <div class="col-lg-5 order-2 order-lg-1">
          <div class="features-box mt-5 mt-lg-0">
            <h3>Преподавател - Таня Илиева</h3>
            <ul class="text-muted list-unstyled margin-t-30 features-item-list black-text">
              <p style="font-style: italic;">Казвам се Таня Илиева и преподавам над 25 години математика на деца. Имах късмета да уча при най-добрите учители по математика и да се влюбя в нея. Работила съм с всякакъв тип деца, преминала съм през различни учебни програми… Обикновено процесът на преподаването на математиката се представя като съвкупност от методи и операции често несвързани и безинтересни за децата. И е жалко, че математиката не се числи към изкуствата, както е било много назад във времето. Ако обучението по изкуствата се водеше по същия начин, то щеше да се превърне в изучаване на начините за дялане на дърво, камък и смесване на бои.
	Бих искала децата, които обучавам в моите курсове да станат нещо повече от майстори по дялане на дърво и камък и смесване на бои. Е, не очаквам да се появи нов Микеланджело, но ми се иска да има повече ценители на Микеланджело и това ми се струва много важно. Обичам да разкривам сравнително непознат свят за децата. В часовете за упражнения се набляга на индивидуалния начин на мислене и самостоятелното откриване на решенията. Подбраните задачи привличат учениците с високата си интелигентност. Стремя се в часовете да намирам свеж подход към математиката, да прониквам в душите на учениците. Темите са разнообразни, добре систематизирани, поднесени на достъпен език и с чувство за хумор. Част от задачите провокират и родителите да поддържат авторитета си на “всезнаещи“.
В часовете учениците развиват способността си да разсъждават логично и да представят аргументи по честен и убедителен начин. Във времето, в което живеем комплексните умения са изключително важни за постигане на максимален напредък и вярвам, че с придобитите знания във FANMATH всяко едно дете ще спечели за тази кауза.</p>
              <h5>Професионален опит:</h5>
              <li class>Учител по математика с II ПКС</li>
              <li class>Над 25-годишен опит в обучението на деца за подготовка в училище, за изпити за НВО, ДЗИ,
                 Американски колеж, за състезания и много други.</li>
              <li class>Съавтор на сборници по математика на издателство "Веди" от 5 до 12 клас (включително и по формата PISA)</li>
                 <li class>Дългогодишен член на националната комисия оценители на ДЗИ по математика и оценител на НВО в 7. и 10. клас.</li>
                
                 <br>
                 <h5>Образование: </h5>
            <p class="text-muted web-desc black-text"
            >
          висше: СУ "Св. Климент Охридски" <br>
        ФМИ, специалност: математика <br>
      средно: МГ "К. Величков" гр. Пазарджик</p>
            </ul>
            
          </div>
        </div>
        <div class="col-lg-7 order-1 order-lg-2">
          <div class="features-img mx-auto mr-lg-0">
            <img style=" margin-left: 40%;width: 50%; border-radius: 10px;   --s: 10px; /* control the size */
  padding: var(--s);
  border: calc(2*var(--s)) solid #0000;
  outline: 1px solid #000;
  outline-offset: calc(-1*var(--s));
  background: conic-gradient(from 90deg at 1px 1px,#0000 25%,#000 0);" src="@/assets/images/fanmath-images/teacher-image.jpg" alt="macbook image" class="img-fluid" />
          </div>
        </div>
      </div>
    </div>
  </section>
      <!-- <BlogMarketing />
      <Contact />
      <Partners/> -->
      <FooterBG />
    </div>
  </div>
</template>

<style scoped>
::v-deep .modal-content {
  background-color: #000000;
  color: white;
  background: none;
  border: none;
}
::v-deep .modal-header {
  border: none;
}
::v-deep .modal-backdrop {
  opacity: 0.5;
}
</style>